<template>
    <div align="center" style="height:auto;">
        <div class="commonSearch bottom" ref="commonSearchRef">
            <div align="left" style="height: 50px;margin:10px 0px 10px 0px">
                <el-upload class="upload-demo" action="#" :class="{ disabled: uploadDisabled }" :http-request="customUpload" :on-change="handleChange" :on-exceed="uploadOverrun" :show-file-list="false">
                    <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
            </div>

            <div class="demo-image" style="width: 80%;height: 740px;margin-top: 15px">
                <el-table :data="fileList" style="width: 100%;height: 80vh;overflow: auto;">
                    <el-table-column label="描述图片">
                        <template slot-scope="scope">
                            <img :src="showPic(scope.row.url)" style="width:100px;height:100px" />
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button size="mini" type="danger" @click="del(scope.$index, scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
import TabResize from "@/utils/TabResizeEx.js";
import RepairsApi from "@/api/repairs.js";
import axios from 'axios'

export default {
    mixins: [TabResize],
    components: {},

    data () {
        return {
            fileList: [], //展示图片
            fits: [],  // 现存图片数据
            pictures: [],
            count: 0,
            imgUid: [],
            imageUrl: "",
            uploadDisabled: false,
        };
    },
    mounted: function () {
        this.findImg();
    },

    methods: {
        //上传图片
        customUpload (file) {
            if (this.count >= 3) {
                this.uploadDisabled = true;
                this.uploadOverrun();
                return;
            }
            let param = {
                file: file.file,
                recordId: "lbt",
                typeId: "10",
            };

            this.$mhttp
                .httpFilePost(
                    this.$constant.API_NSC + "file/upload/single",
                    param,
                    null,
                    (progress) => {
                        let loaded = progress.loaded,
                            total = progress.total;
                        this.$nextTick(() => {
                            this.percent = Math.floor((loaded / total) * 100) > 1 ? Math.floor((loaded / total) * 100) : 1;
                        });
                    }
                ).then((res2) => {
                    if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
                        this.imageUrl = URL.createObjectURL(file.file);
                        this.loadImage(res2.data.data.id);
                        this.count = this.count + 1;
                        this.$message.success("上传成功！");
                    } else {
                        this.$message.error(res2.data.msg);
                        return false;
                    }
                }).catch((err) => {
                    this.$message.error(err);
                    return false;
                });
        },

        //查看图片
        findImg () {
            let typeId = 10;
            let id = "lbt";
            axios.get(this.$constant.API_NSC + 'file/files/type/' + typeId + '/record/' + id, null, null).then(res2 => {
                if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
                    let data = res2.data.data;
                    this.fits = data;
                    for (var i = 0; i < data.length; i++) {
                        this.pictures.push(data[i].id)
                    }
                    this.loadImages(this.pictures);
                } else {
                    this.$message.error(res2.data.msg);
                    return false;
                }
            }).catch(err => {
                this.$message.error(err);
                return false;
            });
        },

        //加载多张图片
        loadImages (userIcons) {
            let imgIds = userIcons;
            for (var i = 0; i < imgIds.length; i++) {
                let item = imgIds[i];
                RepairsApi.getClass()
                    .downloadFile(item)
                    .then(res2 => {
                        let data = res2.data;
                        if (data != null) {
                            this.fileList.push({
                                url: res2.data,
                                id: item
                            });
                            this.count = this.fileList.length;
                        } else {
                            this.fileList.push("");
                        }
                    }).catch(err => {
                        this.fileList.push("");
                        return false;
                    });
            }
        },

        //加载一张图片
        loadImage (userIcon) {
            let imgId = userIcon;
            RepairsApi.getClass()
                .downloadFile(imgId)
                .then(res2 => {
                    let data = res2.data;
                    if (data != null) {
                        this.fileList.push({
                            url: res2.data,
                            id: imgId
                        });
                    } else {
                        this.fileList.push("");
                    }
                }).catch(err => {
                    this.fileList.push("");
                    return false;
                });
        },
        //展示图片
        showPic (val) {
            return URL.createObjectURL(val);
        },
        //上传图片限制数量
        handleChange (file, fileList) {
            if (this.count >= 3) {
                this.uploadDisabled = true;
            }
        },
        //上传图片限制数量提示
        uploadOverrun: function () {
            this.$message({
                type: "error",
                message: "上传文件个数超出限制!最多上传3张图片!",
            });
        },
        //删除按钮
        del (index, val) {
            this.count = this.count - 1;
            let fit = val;

            for (var i = 0; i < this.fileList.length; i++) {
                if (this.fileList[i].id == fit.id) {
                    this.fileList.splice(i, 1);
                    i--;
                }
            }
            this.handleRemoves(fit);
            this.uploadDisabled = false;
        },

        //改变图片的deleted值
        handleRemoves (val) {
            let param = { id: val.id };
            this.$mhttp
                .httpPost(
                    this.$constant.API_NSC + "file/del/" + param.id,
                    null,
                    "application/json"
                )
                .then((res2) => {
                    if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {

                    } else {
                        this.$message.error(res2.data.msg);
                        return false;
                    }
                }).catch((err) => {
                    this.$message.error(err);
                    return false;
                });
        }
    }
};
</script>

<style lang="stylus" scoped>
.block {
    width: 100px;
    height: 100px;
    margin-right: 10px;
    display: inline;
}

.bottom {
    width: 90%;
    height: 820px;
    overflow: auto;
}
</style>